export const selectPackage = (service, message) => {
  window.dispatchEvent(
    new CustomEvent("select-package", { detail: { service, message } })
  );
  document.getElementById("contact")?.scrollIntoView({ behavior: "smooth" });
};
